import {
  getLeoUuid,
  LeoUUID,
  getObject,
  getList,
} from "@surya-digital/leo-ts-types";
import { Order, OrderDTO } from "../types/order";
import { GroupChildQuestionOrder, GroupChildQuestionOrderDTO } from "./groupChildQuestionOrder";

export interface QuestionOrderDTO {
  questionId: string;
  questionOrder: OrderDTO;
  groupChildQuestionOrders: GroupChildQuestionOrderDTO[];
}

export class QuestionOrder {
  readonly isQuestionOrderQuestionOrder: boolean = true;

  readonly questionId: LeoUUID;
  readonly questionOrder: Order;
  readonly groupChildQuestionOrders: GroupChildQuestionOrder[];


  constructor(
  questionId: LeoUUID, 
  questionOrder: Order, 
  groupChildQuestionOrders: GroupChildQuestionOrder[]
  ) {
    this.questionId = questionId;
    this.questionOrder = questionOrder;
    this.groupChildQuestionOrders = groupChildQuestionOrders;
  }

  static fromDTO(dto: QuestionOrderDTO): QuestionOrder {
    const questionId = getLeoUuid(dto, "questionId", InvalidQuestionOrderQuestionIdError);
    const questionOrder = Order.fromDTO(getObject(dto, "questionOrder", InvalidQuestionOrderQuestionOrderError));
    const groupChildQuestionOrders = getList<GroupChildQuestionOrderDTO, GroupChildQuestionOrder>(
      dto,
      "groupChildQuestionOrders",
      GroupChildQuestionOrder.fromDTO,
      InvalidQuestionOrderGroupChildQuestionOrdersError
    );
    return new QuestionOrder(
      questionId,
      questionOrder,
      groupChildQuestionOrders
    );
  }

  toDTO(): QuestionOrderDTO {
    const dto: QuestionOrderDTO = {
        questionId: this.questionId.toDTO(),
        questionOrder: this.questionOrder.toDTO(),
        groupChildQuestionOrders: this.groupChildQuestionOrders.map((e: GroupChildQuestionOrder) => { return e.toDTO() })
    };
    return dto;
  }
  }

QuestionOrder.prototype.toString = function toString(): string {
  return `QuestionOrder(questionId='${this.questionId}',questionOrder='${this.questionOrder}',groupChildQuestionOrders='${this.groupChildQuestionOrders}')`;
};

export class InvalidQuestionOrderError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionOrderError";
  }
}
export class InvalidQuestionOrderQuestionIdError extends InvalidQuestionOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionOrderQuestionIdError";
  }
}

export class InvalidQuestionOrderQuestionOrderError extends InvalidQuestionOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionOrderQuestionOrderError";
  }
}

export class InvalidQuestionOrderGroupChildQuestionOrdersError extends InvalidQuestionOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionOrderGroupChildQuestionOrdersError";
  }
}
